import { type StripePaymentIntent } from "@doitintl/cmp-models";

import { toCurrencyMajorUnits } from "../../../utils/common";
import { type RowItem } from "../InvoiceDetails/invoiceRow";
import { type Invoice } from "../types";

export const isLinkedInvoiceNotCanceled = (paymentIntent: StripePaymentIntent, invoices: Invoice[]) =>
  Boolean(paymentIntent.linked_invoice) &&
  invoices.some((invoice: Invoice) => invoice.IVNUM === paymentIntent.linked_invoice?.invoice_id);

export const calculateTotalWFees = (invoiceData: RowItem, invoices: Invoice[]) => {
  const paymentFeesInMinorUnits = invoiceData?.stripePaymentIntents?.reduce(
    (acc: number, paymentIntent: StripePaymentIntent) => {
      if (
        paymentIntent.linked_invoice &&
        isLinkedInvoiceNotCanceled(paymentIntent, invoices) &&
        paymentIntent.status !== "canceled"
      ) {
        return acc + paymentIntent.linked_invoice.amount_fees;
      }

      return acc;
    },
    0
  );

  const paymentFeesInMajorUnits = toCurrencyMajorUnits(paymentFeesInMinorUnits ?? 0, invoiceData.SYMBOL);

  return paymentFeesInMajorUnits + invoiceData.TOTPRICE;
};
